module.exports = __webpack_public_path__ + "img/celestial.d65546d0.png";